!(function (t) {
    var e = {};
    function n(i) {
        if (e[i]) return e[i].exports;
        var s = (e[i] = { i: i, l: !1, exports: {} });
        return t[i].call(s.exports, s, s.exports, n), (s.l = !0), s.exports;
    }
    (n.m = t),
        (n.c = e),
        (n.d = function (t, e, i) {
            n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
        }),
        (n.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (n.t = function (t, e) {
            if ((1 & e && (t = n(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var i = Object.create(null);
            if ((n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
                for (var s in t)
                    n.d(
                        i,
                        s,
                        function (e) {
                            return t[e];
                        }.bind(null, s)
                    );
            return i;
        }),
        (n.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return n.d(e, "a", e), e;
        }),
        (n.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (n.p = ""),
        n((n.s = 31));
})({
    0: function (t, e, n) {
        "use strict";
        n.d(e, "g", function () {
            return s;
        }),
            n.d(e, "k", function () {
                return r;
            }),
            n.d(e, "j", function () {
                return a;
            }),
            n.d(e, "b", function () {
                return o;
            }),
            n.d(e, "l", function () {
                return c;
            }),
            n.d(e, "a", function () {
                return l;
            }),
            n.d(e, "d", function () {
                return u;
            }),
            n.d(e, "h", function () {
                return d;
            }),
            n.d(e, "f", function () {
                return p;
            }),
            n.d(e, "c", function () {
                return h;
            }),
            n.d(e, "e", function () {
                return m;
            }),
            n.d(e, "i", function () {
                return f;
            });
        var i = document.querySelector("[data-site-container]");
        function s() {
            (i.style.overflowY = "hidden"), (i.style.height = "100dvh");
        }
        function r() {
            i.style.removeProperty("overflow"), (i.style.height = "auto");
        }
        function a(t, e, n) {
            let i = "";
            if (n && "" !== n) {
                let t = new Date();
                t.setTime(t.getTime() + 24 * n * 60 * 60 * 1e3), (i = "; expires=" + t.toUTCString());
            } else i = '; expires=""';
            document.cookie = `${t}=${e}${i}; path=/`;
        }
        function o(t) {
            let e = t + "=",
                n = document.cookie.split(";");
            for (let t = 0; t < n.length; t++) {
                let i = n[t];
                for (; " " == i.charAt(0); ) i = i.substring(1);
                if (-1 != i.indexOf(e)) return i.substring(e.length, i.length);
            }
            return null;
        }
        function c(t) {
            const e = t.includes("&") ? t.split("&")[0] : t,
                n = document.querySelector('[type="application/ld+json"]'),
                i = n.innerHTML;
            let [s, r] = i.split('"@id": "');
            (r = r.split(r.split('"')[0])[1]), console.log(`${s}"@id": "${e}${r}`), (n.innerHTML = `${s}"@id": "${e}${r}`), (document.querySelector('[rel="canonical"]').href = theme.url + e);
        }
        const l = (t, e) => {
            let n;
            return function (...i) {
                n && clearTimeout(n),
                    (n = setTimeout(() => {
                        t(...i);
                    }, e));
            };
        };
        async function u(t) {
            const e = await fetch(t, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
            return await e.json();
        }
        async function d(t, e, n = {}) {
            const i = await fetch(t, { method: "POST", headers: { "Content-Type": "application/json", ...n }, body: JSON.stringify(e) });
            if (!i.ok) throw new Error("HTTP error! Status: " + i.status);
            return await i.json();
        }
        async function p(t) {
            const e = t.handle ? "/products/" + t.handle : t.mappings.core.url,
                n = t.params && t.params.lazyload ? "" : "&lazyload=false",
                i = t.params && t.params.isSlide ? "&slide=true" : "",
                s = t.params && "false" == t.params.showWishlist ? "&wishlist=false" : "",
                r = t.params && "false" == t.params.showStrips ? "&featureStrips=false" : "",
                a = t.params && "false" == t.params.showReviews ? "&reviews=false" : "",
                o = t.params && "false" == t.params.showRoundels ? "&roundels=false" : "",
                c = t.params && "true" == t.params.altImage ? "&alternatePicture=true" : "",
                l = t.params && void 0 !== t.params.index ? "&index=" + t.params.index : "",
                u = `${e}?sections=product-list-item${n}${i}${a}${o}${c}${s}${r}${t.intellisuggestData ? "&intellisuggestData=" + t.intellisuggestData : ""}${
                    t.intellisuggestSignature ? "&intellisuggestSignature=" + t.intellisuggestSignature : ""
                }${l}`;
            return await fetch(u, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        async function h(t, e) {
            const n = t.handle ? "/products/" + t.handle : t.mappings.core.url,
                i = await (async function (t) {
                    try {
                        let e = await fetch(t);
                        if (!e.ok) throw new Error(`HTTP error for endpoint ${t} - Status: ${e.status}`);
                        return await e.json();
                    } catch (t) {
                        return console.error("Error fetching data:", t), {};
                    }
                })(n + "?view=gaData");
            return (function (t, e = {}, n) {
                const i = t.mappings ? { id: t.id, ...t.mappings.core } : t,
                    s = { index: n, discount: i.msrp - i.price, item_brand: i.brand, price: i.price, quantity: 1 };
                return (
                    i.product_type_unigram && (s.item_variant = i.product_type_unigram),
                    e.item_id || (s.item_id = i.id),
                    e.item_name || (s.item_name = i.name),
                    t.mappings ? (s.item_category4 = "Rec: " + t.params.placementTag) : theme.relativeItemCategory && (s.item_category4 = theme.relativeItemCategory),
                    { ...s, ...e }
                );
            })(t, (await i).product, e);
        }
        async function m(t) {
            const e = `/products/${t.handle}?sections=product-list-item&lazyload=false`;
            return await fetch(e, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        function f(t, e, n = theme.collectionName, i = theme.collectionTitle) {
            console.log(e), console.log({ item_list_id: n || "", item_list_name: i || theme.relativeItemCategory, items: t });
        }
    },
    1: function (t, e, n) {
        "use strict";
        let i;
        n.r(e),
            n.d(e, "v1", function () {
                return f;
            }),
            n.d(e, "v3", function () {
                return j;
            }),
            n.d(e, "v4", function () {
                return _;
            }),
            n.d(e, "v5", function () {
                return U;
            }),
            n.d(e, "NIL", function () {
                return x;
            }),
            n.d(e, "version", function () {
                return k;
            }),
            n.d(e, "validate", function () {
                return o;
            }),
            n.d(e, "stringify", function () {
                return u;
            }),
            n.d(e, "parse", function () {
                return g;
            });
        const s = new Uint8Array(16);
        function r() {
            if (!i && ((i = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)), !i))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            return i(s);
        }
        var a = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i,
            o = function (t) {
                return "string" == typeof t && a.test(t);
            };
        const c = [];
        for (let t = 0; t < 256; ++t) c.push((t + 256).toString(16).slice(1));
        function l(t, e = 0) {
            return (
                c[t[e + 0]] +
                c[t[e + 1]] +
                c[t[e + 2]] +
                c[t[e + 3]] +
                "-" +
                c[t[e + 4]] +
                c[t[e + 5]] +
                "-" +
                c[t[e + 6]] +
                c[t[e + 7]] +
                "-" +
                c[t[e + 8]] +
                c[t[e + 9]] +
                "-" +
                c[t[e + 10]] +
                c[t[e + 11]] +
                c[t[e + 12]] +
                c[t[e + 13]] +
                c[t[e + 14]] +
                c[t[e + 15]]
            );
        }
        var u = function (t, e = 0) {
            const n = l(t, e);
            if (!o(n)) throw TypeError("Stringified UUID is invalid");
            return n;
        };
        let d,
            p,
            h = 0,
            m = 0;
        var f = function (t, e, n) {
                let i = (e && n) || 0;
                const s = e || new Array(16);
                let a = (t = t || {}).node || d,
                    o = void 0 !== t.clockseq ? t.clockseq : p;
                if (null == a || null == o) {
                    const e = t.random || (t.rng || r)();
                    null == a && (a = d = [1 | e[0], e[1], e[2], e[3], e[4], e[5]]), null == o && (o = p = 16383 & ((e[6] << 8) | e[7]));
                }
                let c = void 0 !== t.msecs ? t.msecs : Date.now(),
                    u = void 0 !== t.nsecs ? t.nsecs : m + 1;
                const f = c - h + (u - m) / 1e4;
                if ((f < 0 && void 0 === t.clockseq && (o = (o + 1) & 16383), (f < 0 || c > h) && void 0 === t.nsecs && (u = 0), u >= 1e4)) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                (h = c), (m = u), (p = o), (c += 122192928e5);
                const g = (1e4 * (268435455 & c) + u) % 4294967296;
                (s[i++] = (g >>> 24) & 255), (s[i++] = (g >>> 16) & 255), (s[i++] = (g >>> 8) & 255), (s[i++] = 255 & g);
                const y = ((c / 4294967296) * 1e4) & 268435455;
                (s[i++] = (y >>> 8) & 255), (s[i++] = 255 & y), (s[i++] = ((y >>> 24) & 15) | 16), (s[i++] = (y >>> 16) & 255), (s[i++] = (o >>> 8) | 128), (s[i++] = 255 & o);
                for (let t = 0; t < 6; ++t) s[i + t] = a[t];
                return e || l(s);
            },
            g = function (t) {
                if (!o(t)) throw TypeError("Invalid UUID");
                let e;
                const n = new Uint8Array(16);
                return (
                    (n[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24),
                    (n[1] = (e >>> 16) & 255),
                    (n[2] = (e >>> 8) & 255),
                    (n[3] = 255 & e),
                    (n[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8),
                    (n[5] = 255 & e),
                    (n[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8),
                    (n[7] = 255 & e),
                    (n[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8),
                    (n[9] = 255 & e),
                    (n[10] = ((e = parseInt(t.slice(24, 36), 16)) / 1099511627776) & 255),
                    (n[11] = (e / 4294967296) & 255),
                    (n[12] = (e >>> 24) & 255),
                    (n[13] = (e >>> 16) & 255),
                    (n[14] = (e >>> 8) & 255),
                    (n[15] = 255 & e),
                    n
                );
            };
        function y(t, e, n) {
            function i(t, i, s, r) {
                var a;
                if (
                    ("string" == typeof t &&
                        (t = (function (t) {
                            t = unescape(encodeURIComponent(t));
                            const e = [];
                            for (let n = 0; n < t.length; ++n) e.push(t.charCodeAt(n));
                            return e;
                        })(t)),
                    "string" == typeof i && (i = g(i)),
                    16 !== (null === (a = i) || void 0 === a ? void 0 : a.length))
                )
                    throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                let o = new Uint8Array(16 + t.length);
                if ((o.set(i), o.set(t, i.length), (o = n(o)), (o[6] = (15 & o[6]) | e), (o[8] = (63 & o[8]) | 128), s)) {
                    r = r || 0;
                    for (let t = 0; t < 16; ++t) s[r + t] = o[t];
                    return s;
                }
                return l(o);
            }
            try {
                i.name = t;
            } catch (t) {}
            return (i.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8"), (i.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8"), i;
        }
        function v(t) {
            return 14 + (((t + 64) >>> 9) << 4) + 1;
        }
        function S(t, e) {
            const n = (65535 & t) + (65535 & e);
            return (((t >> 16) + (e >> 16) + (n >> 16)) << 16) | (65535 & n);
        }
        function b(t, e, n, i, s, r) {
            return S(((a = S(S(e, t), S(i, r))) << (o = s)) | (a >>> (32 - o)), n);
            var a, o;
        }
        function w(t, e, n, i, s, r, a) {
            return b((e & n) | (~e & i), t, e, s, r, a);
        }
        function I(t, e, n, i, s, r, a) {
            return b((e & i) | (n & ~i), t, e, s, r, a);
        }
        function A(t, e, n, i, s, r, a) {
            return b(e ^ n ^ i, t, e, s, r, a);
        }
        function $(t, e, n, i, s, r, a) {
            return b(n ^ (e | ~i), t, e, s, r, a);
        }
        var j = y("v3", 48, function (t) {
                if ("string" == typeof t) {
                    const e = unescape(encodeURIComponent(t));
                    t = new Uint8Array(e.length);
                    for (let n = 0; n < e.length; ++n) t[n] = e.charCodeAt(n);
                }
                return (function (t) {
                    const e = [],
                        n = 32 * t.length;
                    for (let i = 0; i < n; i += 8) {
                        const n = (t[i >> 5] >>> i % 32) & 255,
                            s = parseInt("0123456789abcdef".charAt((n >>> 4) & 15) + "0123456789abcdef".charAt(15 & n), 16);
                        e.push(s);
                    }
                    return e;
                })(
                    (function (t, e) {
                        (t[e >> 5] |= 128 << e % 32), (t[v(e) - 1] = e);
                        let n = 1732584193,
                            i = -271733879,
                            s = -1732584194,
                            r = 271733878;
                        for (let e = 0; e < t.length; e += 16) {
                            const a = n,
                                o = i,
                                c = s,
                                l = r;
                            (n = w(n, i, s, r, t[e], 7, -680876936)),
                                (r = w(r, n, i, s, t[e + 1], 12, -389564586)),
                                (s = w(s, r, n, i, t[e + 2], 17, 606105819)),
                                (i = w(i, s, r, n, t[e + 3], 22, -1044525330)),
                                (n = w(n, i, s, r, t[e + 4], 7, -176418897)),
                                (r = w(r, n, i, s, t[e + 5], 12, 1200080426)),
                                (s = w(s, r, n, i, t[e + 6], 17, -1473231341)),
                                (i = w(i, s, r, n, t[e + 7], 22, -45705983)),
                                (n = w(n, i, s, r, t[e + 8], 7, 1770035416)),
                                (r = w(r, n, i, s, t[e + 9], 12, -1958414417)),
                                (s = w(s, r, n, i, t[e + 10], 17, -42063)),
                                (i = w(i, s, r, n, t[e + 11], 22, -1990404162)),
                                (n = w(n, i, s, r, t[e + 12], 7, 1804603682)),
                                (r = w(r, n, i, s, t[e + 13], 12, -40341101)),
                                (s = w(s, r, n, i, t[e + 14], 17, -1502002290)),
                                (i = w(i, s, r, n, t[e + 15], 22, 1236535329)),
                                (n = I(n, i, s, r, t[e + 1], 5, -165796510)),
                                (r = I(r, n, i, s, t[e + 6], 9, -1069501632)),
                                (s = I(s, r, n, i, t[e + 11], 14, 643717713)),
                                (i = I(i, s, r, n, t[e], 20, -373897302)),
                                (n = I(n, i, s, r, t[e + 5], 5, -701558691)),
                                (r = I(r, n, i, s, t[e + 10], 9, 38016083)),
                                (s = I(s, r, n, i, t[e + 15], 14, -660478335)),
                                (i = I(i, s, r, n, t[e + 4], 20, -405537848)),
                                (n = I(n, i, s, r, t[e + 9], 5, 568446438)),
                                (r = I(r, n, i, s, t[e + 14], 9, -1019803690)),
                                (s = I(s, r, n, i, t[e + 3], 14, -187363961)),
                                (i = I(i, s, r, n, t[e + 8], 20, 1163531501)),
                                (n = I(n, i, s, r, t[e + 13], 5, -1444681467)),
                                (r = I(r, n, i, s, t[e + 2], 9, -51403784)),
                                (s = I(s, r, n, i, t[e + 7], 14, 1735328473)),
                                (i = I(i, s, r, n, t[e + 12], 20, -1926607734)),
                                (n = A(n, i, s, r, t[e + 5], 4, -378558)),
                                (r = A(r, n, i, s, t[e + 8], 11, -2022574463)),
                                (s = A(s, r, n, i, t[e + 11], 16, 1839030562)),
                                (i = A(i, s, r, n, t[e + 14], 23, -35309556)),
                                (n = A(n, i, s, r, t[e + 1], 4, -1530992060)),
                                (r = A(r, n, i, s, t[e + 4], 11, 1272893353)),
                                (s = A(s, r, n, i, t[e + 7], 16, -155497632)),
                                (i = A(i, s, r, n, t[e + 10], 23, -1094730640)),
                                (n = A(n, i, s, r, t[e + 13], 4, 681279174)),
                                (r = A(r, n, i, s, t[e], 11, -358537222)),
                                (s = A(s, r, n, i, t[e + 3], 16, -722521979)),
                                (i = A(i, s, r, n, t[e + 6], 23, 76029189)),
                                (n = A(n, i, s, r, t[e + 9], 4, -640364487)),
                                (r = A(r, n, i, s, t[e + 12], 11, -421815835)),
                                (s = A(s, r, n, i, t[e + 15], 16, 530742520)),
                                (i = A(i, s, r, n, t[e + 2], 23, -995338651)),
                                (n = $(n, i, s, r, t[e], 6, -198630844)),
                                (r = $(r, n, i, s, t[e + 7], 10, 1126891415)),
                                (s = $(s, r, n, i, t[e + 14], 15, -1416354905)),
                                (i = $(i, s, r, n, t[e + 5], 21, -57434055)),
                                (n = $(n, i, s, r, t[e + 12], 6, 1700485571)),
                                (r = $(r, n, i, s, t[e + 3], 10, -1894986606)),
                                (s = $(s, r, n, i, t[e + 10], 15, -1051523)),
                                (i = $(i, s, r, n, t[e + 1], 21, -2054922799)),
                                (n = $(n, i, s, r, t[e + 8], 6, 1873313359)),
                                (r = $(r, n, i, s, t[e + 15], 10, -30611744)),
                                (s = $(s, r, n, i, t[e + 6], 15, -1560198380)),
                                (i = $(i, s, r, n, t[e + 13], 21, 1309151649)),
                                (n = $(n, i, s, r, t[e + 4], 6, -145523070)),
                                (r = $(r, n, i, s, t[e + 11], 10, -1120210379)),
                                (s = $(s, r, n, i, t[e + 2], 15, 718787259)),
                                (i = $(i, s, r, n, t[e + 9], 21, -343485551)),
                                (n = S(n, a)),
                                (i = S(i, o)),
                                (s = S(s, c)),
                                (r = S(r, l));
                        }
                        return [n, i, s, r];
                    })(
                        (function (t) {
                            if (0 === t.length) return [];
                            const e = 8 * t.length,
                                n = new Uint32Array(v(e));
                            for (let i = 0; i < e; i += 8) n[i >> 5] |= (255 & t[i / 8]) << i % 32;
                            return n;
                        })(t),
                        8 * t.length
                    )
                );
            }),
            T = { randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto) },
            _ = function (t, e, n) {
                if (T.randomUUID && !e && !t) return T.randomUUID();
                const i = (t = t || {}).random || (t.rng || r)();
                if (((i[6] = (15 & i[6]) | 64), (i[8] = (63 & i[8]) | 128), e)) {
                    n = n || 0;
                    for (let t = 0; t < 16; ++t) e[n + t] = i[t];
                    return e;
                }
                return l(i);
            };
        function R(t, e, n, i) {
            switch (t) {
                case 0:
                    return (e & n) ^ (~e & i);
                case 1:
                case 3:
                    return e ^ n ^ i;
                case 2:
                    return (e & n) ^ (e & i) ^ (n & i);
            }
        }
        function C(t, e) {
            return (t << e) | (t >>> (32 - e));
        }
        var U = y("v5", 80, function (t) {
                const e = [1518500249, 1859775393, 2400959708, 3395469782],
                    n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
                if ("string" == typeof t) {
                    const e = unescape(encodeURIComponent(t));
                    t = [];
                    for (let n = 0; n < e.length; ++n) t.push(e.charCodeAt(n));
                } else Array.isArray(t) || (t = Array.prototype.slice.call(t));
                t.push(128);
                const i = t.length / 4 + 2,
                    s = Math.ceil(i / 16),
                    r = new Array(s);
                for (let e = 0; e < s; ++e) {
                    const n = new Uint32Array(16);
                    for (let i = 0; i < 16; ++i) n[i] = (t[64 * e + 4 * i] << 24) | (t[64 * e + 4 * i + 1] << 16) | (t[64 * e + 4 * i + 2] << 8) | t[64 * e + 4 * i + 3];
                    r[e] = n;
                }
                (r[s - 1][14] = (8 * (t.length - 1)) / Math.pow(2, 32)), (r[s - 1][14] = Math.floor(r[s - 1][14])), (r[s - 1][15] = (8 * (t.length - 1)) & 4294967295);
                for (let t = 0; t < s; ++t) {
                    const i = new Uint32Array(80);
                    for (let e = 0; e < 16; ++e) i[e] = r[t][e];
                    for (let t = 16; t < 80; ++t) i[t] = C(i[t - 3] ^ i[t - 8] ^ i[t - 14] ^ i[t - 16], 1);
                    let s = n[0],
                        a = n[1],
                        o = n[2],
                        c = n[3],
                        l = n[4];
                    for (let t = 0; t < 80; ++t) {
                        const n = Math.floor(t / 20),
                            r = (C(s, 5) + R(n, a, o, c) + l + e[n] + i[t]) >>> 0;
                        (l = c), (c = o), (o = C(a, 30) >>> 0), (a = s), (s = r);
                    }
                    (n[0] = (n[0] + s) >>> 0), (n[1] = (n[1] + a) >>> 0), (n[2] = (n[2] + o) >>> 0), (n[3] = (n[3] + c) >>> 0), (n[4] = (n[4] + l) >>> 0);
                }
                return [
                    (n[0] >> 24) & 255,
                    (n[0] >> 16) & 255,
                    (n[0] >> 8) & 255,
                    255 & n[0],
                    (n[1] >> 24) & 255,
                    (n[1] >> 16) & 255,
                    (n[1] >> 8) & 255,
                    255 & n[1],
                    (n[2] >> 24) & 255,
                    (n[2] >> 16) & 255,
                    (n[2] >> 8) & 255,
                    255 & n[2],
                    (n[3] >> 24) & 255,
                    (n[3] >> 16) & 255,
                    (n[3] >> 8) & 255,
                    255 & n[3],
                    (n[4] >> 24) & 255,
                    (n[4] >> 16) & 255,
                    (n[4] >> 8) & 255,
                    255 & n[4],
                ];
            }),
            x = "00000000-0000-0000-0000-000000000000",
            k = function (t) {
                if (!o(t)) throw TypeError("Invalid UUID");
                return parseInt(t.slice(14, 15), 16);
            };
    },
    31: function (t, e, n) {
        t.exports = n(32);
    },
    32: function (t, e, n) {
        "use strict";
        console.log("ss-recs vanilla slider v4 loaded");
        n.r(e);
        var i = n(0);
        const s = n(1),
            r = {
                recsContainer: "[data-ss-recommendations]",
                title: "[data-recs-title]",
                cartRecs: ".section-cart",
                productItem: ".product-list-item",
                slide: ".ss-rec-slide",
                activeSlideClass: "ss-rec-slide--active",
                indexAttr: "data-index",
                skuAttr: "data-product-sku",
            },
            a = void {
                onLoad() {
                    (this.endpoints = { recommendations: `https://${theme.siteId}.a.searchspring.io/boost/${theme.siteId}/recommend?`, beacon: "https://beacon.searchspring.io/beacon" }),
                        (this.container = document.querySelector(r.recsContainer)),
                        (this.title = document.querySelector(r.title)),
                        (this.productItemSection = "product-list-item"),
                        (this.placementSettings = this.container.dataset),
                        (this.placementParams = {
                            showReviews: this.placementSettings.enableReviews,
                            showWishlist: this.placementSettings.enableWishlist,
                            showStrips: this.placementSettings.enableStrips,
                            showRoundels: this.placementSettings.enableRoundels,
                            altImage: this.placementSettings.altImage,
                            lazyload: !1,
                            isSlide: !0,
                            placementTag: this.placementSettings.tags,
                        }),
                        (this.classes = { grid: "is-grid", loadingSpinner: "loading-spinner", loading: "is-loading" }),
                        this.setupCookieVariables(),
                        this.loadRecommendedResults();
                },
                setupCookieVariables() {
                    (this.pageLoadId = s.v4()),
                        (this.userId = Object(i.b)("ssUserId")),
                        (this.isuid = Object(i.b)("_isuid")),
                        (this.sessionId = Object(i.b)("ssSessionIdNamespace")),
                        (this.storedShopper = Object(i.b)("ssShopperId")),
                        (this.cart = Object(i.b)("ssCartProducts"));
                    const t = Object(i.b)("ssViewedProducts");
                    this.lastViewed = t ? t.split("%2C").join(",") : "";
                },
                createTemplateBeaconData(t = !1) {
                    const e = {
                        category: "searchspring.recommendations.user-interactions",
                        context: { pageLoadId: this.pageLoadId, userId: this.userId, sessionId: this.sessionId, website: { trackingCode: theme.siteId } },
                        event: { context: { type: "product-recommendation", tag: this.placementSettings.tags } },
                    };
                    return (
                        t && ((e.event.profile = { tag: this.placementSettings.tags, seed: [""] }), this.placementSettings.placement && (e.event.profile.placement = this.placementSettings.placement)),
                        this.placementSettings.placement && (e.event.context.placement = this.placementSettings.placement),
                        e
                    );
                },
                async sendBeaconData(t = [], e) {
                    const n = [],
                        r = s.v4(),
                        a = { ...this.createTemplateBeaconData(!0), id: r, type: "interaction" === e ? "profile.click" : "profile." + e };
                    return (
                        n.push(a),
                        t.forEach((t) => {
                            const i = s.v4(),
                                a = { ...this.createTemplateBeaconData(), id: i, pid: r, type: "interaction" === e ? "profile.product.impression" : "profile.product." + e };
                            (a.event.product = { id: t.id, mappings: t.mappings }), n.push(a);
                        }),
                        Object(i.h)(this.endpoints.beacon, n)
                    );
                },
                getActiveItems() {
                    const t = [...this.container.querySelectorAll(r.slide)].filter((t) => t.classList.contains(r.activeSlideClass)),
                        e = [];
                    return (
                        t.forEach((t) => {
                            const n = t.querySelector(r.productItem),
                                i = !(!n || !n.hasAttribute(r.indexAttr)) && n.getAttribute(r.indexAttr);
                            i && e.push(this.currentResultsArray[i]);
                        }),
                        e
                    );
                },
                addItemClickListeners() {
                    async function t(t) {
                        if (!0 === this.clickLogged) return;
                        t.preventDefault();
                        const e = t.target.classList.contains(r.productItem.replace(".", "")) ? t.target : t.target.closest(r.productItem),
                            n = this.currentResultsArray[e.dataset.index];
                        if ((console.log("current results length: ", this.currentResultsArray.length), console.log(n, e.dataset.index), n && n.id && n.mappings && this.gaItems)) {
                            const t = this.gaItems.find((t) => String(t.item_id) === e.getAttribute(r.skuAttr));
                            Object(i.i)([t], "select_item", this.placementSettings.tags, "Recommendation Placement: " + this.placementSettings.tags), await this.sendBeaconData([n], "click");
                        }
                        (this.clickLogged = !0), t.target.click();
                    }
                    this.container.querySelectorAll(r.productItem).forEach((e) => {
                        e.addEventListener("click", t.bind(this));
                    });
                },
                addIntersectionObserver(t) {
                    const e = { root: null, rootMargin: "0px", threshold: theme.recPercentVisible };
                    new IntersectionObserver((t, e) => {
                        t.forEach((t) => {
                            if (t.isIntersecting) {
                                const t = this.getActiveItems();
                                this.sendBeaconData(t, "impression");
                            }
                        });
                    }, e).observe(t);
                },
                async loadRecommendedResults() {
                    if (!this.placementSettings.tags) return console.error("At least one recommendations placement tag must be specified to load recommendations"), void this.title.setAttribute("hidden", "hidden");
                    this.setLoading();
                    let t = (await this.getSearchspringSearchApiResults()).map((t) => t.results).flat(1);
                    (t = t.filter((t) => t.id !== this.placementSettings.productId)), (this.currentResultsArray = t), t.forEach((t, e) => (t.params = { ...this.placementParams, index: e }));
                    const e = t ? await t.map(i.f) : [];
                    Promise.all(e).then((t) => {
                        const e = t.map((t) => t.json());
                        Promise.all(e).then((t) => {
                            const e = t.map((t) => t[this.productItemSection]).join("");
                            (this.container.innerHTML = e), "true" == this.placementSettings.enableSlider && this.initSlider(), this.addItemClickListeners(), this.setLoaded();             // Re-apply sitewide discount messages to loaded recommendations
                            if (typeof applySitewideDiscountMessages === "function") {
                                applySitewideDiscountMessages();
                            }

                        });
                    });
                },
                async getSearchspringSearchApiResults() {
                    const t = this.placementSettings.product ? "&product=" + this.placementSettings.product : "",
                        e = this.placementSettings.categories ? "&categories=" + this.placementSettings.categories : "",
                        n = this.placementSettings.brands ? "&brands=" + this.placementSettings.brands : "",
                        s = `tags=${this.placementSettings.tags}&shopper=${this.storedShopper}&cart=${this.cart}&lastViewed=${this.lastViewed}&limits=${this.placementSettings.limit}${t}${e}${n}`,
                        r = `${this.endpoints.recommendations}${s}`;
                    return await Object(i.d)(r);
                },
                setLoading() {
                    const t = document.createElement("div");
                    t.classList.add(this.classes.loadingSpinner), this.container.appendChild(t), this.container.classList.add(this.classes.loading);
                },
                async setLoaded() {
                    this.container.classList.remove(this.classes.loading), theme.wishlistModal();
                    const t = this.currentResultsArray.map(i.c),
                        e = await Promise.all(t);
                    (this.gaItems = e),
                        this.sendBeaconData(this.currentResultsArray, "render"),
                        Object(i.i)(this.gaItems, "view_item_list", this.placementSettings.tags, "Recommendation Placement: " + this.placementSettings.tags),
                        this.addIntersectionObserver(this.container);
                },
                initSlider() {
                    const e = this.container;
                    if (!e) return;

                    const n = this;
                    const i = {
                        gapFallback: 16,
                        dragThresholdRatio: 0.15,
                    };

                    function o() {
                        const t = window.innerWidth;
                        let e = 6;

                        if (t <= 600) e = 2;
                        else if (t <= 767) e = 3;
                        else if (t <= 1023) e = 4;
                        else if (t <= 1500) e = 5;

                        return {
                            slidesToShow: e,
                        };
                    }

                    function c(t) {
                        const e = document.createElement("button");
                        e.type = "button";
                        e.className = "ss-rec-arrow ss-rec-arrow--" + t;
                        e.setAttribute("aria-label", "prev" === t ? "Previous recommendations" : "Next recommendations");
                        e.innerHTML = "prev" === t ? '<i class="icon-chevron-left" aria-hidden="true"></i>' : '<i class="icon-chevron-right" aria-hidden="true"></i>';
                        return e;
                    }

                    function l(t) {
                        return Array.from(t.children).filter((t) => !t.classList.contains("ss-rec-viewport") && !t.classList.contains("ss-rec-arrow"));
                    }

                    function u(t, e, n) {
                        return Math.max(e, Math.min(t, n));
                    }

                    function d(t, e) {
                        t.track.style.transform = "translate3d(" + e + "px, 0, 0)";
                    }

                    function p(t) {
                        return -t.index * t.step;
                    }

                    function h(t) {
                        t.slides.forEach((e, n) => {
                            const i = n >= t.index && n < t.index + t.visibleSlides;
                            e.classList.toggle(r.activeSlideClass, i);
                            e.setAttribute("aria-hidden", i ? "false" : "true");
                        });
                    }

                    function m(t) {
                        const e = t.maxIndex <= 0;
                        t.root.classList.toggle("is-static", e);
                        t.prev.disabled = t.index <= 0;
                        t.next.disabled = t.index >= t.maxIndex;
                    }

                    function f(t, e = !1) {
                        if (!e) return;

                        const i = n.getActiveItems();
                        i.length && n.sendBeaconData(i, "interaction");
                    }

                    function g(t, e, n = !1) {
                        const i = t.index;
                        t.index = u(e, 0, t.maxIndex);
                        d(t, p(t));
                        h(t);
                        m(t);
                        f(t, n && i !== t.index);
                    }

                    function y(t) {
                        const e = l(t.root);

                        e.forEach((e) => {
                            e.classList.add("ss-rec-slide");
                            t.track.appendChild(e);
                        });

                        t.slides = Array.from(t.track.children);
                    }

                    function v(t) {
                        y(t);

                        const e = o();
                        const n = t.slides.length;

                        if (!n) return;

                        const s = t.viewport.getBoundingClientRect().width;
                        const r = window.getComputedStyle(t.track);
                        const a = parseFloat(r.columnGap || r.gap) || i.gapFallback;
                        const c = Math.min(e.slidesToShow, n);

                        t.root.setAttribute("data-ss-slides-to-show", String(e.slidesToShow));
                        t.root.classList.toggle("has-peek", window.innerWidth <= 960 && n > c);

                        const l = t.slides[0] && t.slides[0].getBoundingClientRect().width;
                        const u = l || (s - a * (c - 1)) / c;

                        t.visibleSlides = c;
                        t.slideWidth = Math.max(0, u);
                        t.step = t.slideWidth + a;
                        t.maxIndex = Math.max(0, n - c);

                        t.index = Math.max(0, Math.min(t.index, t.maxIndex));
                        d(t, p(t));
                        h(t);
                        m(t);
                    }

                    function S(t) {
                        t.prev.addEventListener("click", () => g(t, t.index - 1, !0));
                        t.next.addEventListener("click", () => g(t, t.index + 1, !0));

                        t.viewport.addEventListener("pointerdown", (e) => {
                            if (e.pointerType !== "touch") return;

                            t.pointerId = e.pointerId;
                            t.startX = e.clientX;
                            t.startY = e.clientY;
                            t.baseX = p(t);
                            t.deltaX = 0;
                            t.isPointerDown = !0;
                            t.hasDragged = !1;
                            t.verticalLocked = !1;
                            t.viewport.setPointerCapture && t.viewport.setPointerCapture(e.pointerId);
                        });

                        t.viewport.addEventListener("pointermove", (e) => {
                            if (!t.isPointerDown) return;

                            const n = e.clientX - t.startX;
                            const s = e.clientY - t.startY;

                            if (!t.hasDragged) {
                                if (Math.abs(s) > Math.abs(n) && Math.abs(s) > 8) {
                                    t.verticalLocked = !0;
                                    return;
                                }

                                if (Math.abs(n) < 4) return;

                                t.hasDragged = !0;
                                t.root.classList.add("is-dragging");
                            }

                            if (t.verticalLocked) return;

                            e.preventDefault();
                            t.deltaX = n;

                            const r = -t.maxIndex * t.step;
                            let a = t.baseX + n;

                            if (a > 0) a *= 0.28;
                            else if (a < r) a = r + 0.28 * (a - r);

                            d(t, a);
                        });

                        function e() {
                            if (!t.isPointerDown) return;

                            t.isPointerDown = !1;
                            t.root.classList.remove("is-dragging");

                            if (!t.hasDragged || t.verticalLocked) {
                                g(t, t.index);
                                return;
                            }

                            const e = t.slideWidth * i.dragThresholdRatio;
                            const n = Math.max(1, Math.round(Math.abs(t.deltaX) / t.step));

                            if (t.deltaX < -e) g(t, t.index + n, !0);
                            else if (t.deltaX > e) g(t, t.index - n, !0);
                            else g(t, t.index);

                            t.justDragged = !0;
                            window.setTimeout(() => {
                                t.justDragged = !1;
                            }, 250);
                        }

                        t.viewport.addEventListener("pointerup", e);
                        t.viewport.addEventListener("pointercancel", e);
                        t.viewport.addEventListener("lostpointercapture", e);

                        t.viewport.addEventListener(
                            "click",
                            (e) => {
                                if (!t.justDragged) return;
                                e.preventDefault();
                                e.stopPropagation();
                            },
                            !0
                        );

                        if ("ResizeObserver" in window) {
                            t.resizeObserver = new ResizeObserver(() => v(t));
                            t.resizeObserver.observe(t.viewport);
                        } else window.addEventListener("resize", () => v(t));
                    }

                    function b(e) {
                        const n = e.ssRecSlider;

                        if (n && e.contains(n.viewport)) {
                            v(n);
                            return;
                        }

                        const i = l(e);
                        if (!i.length) return;

                        e.classList.add("ss-rec-slider");

                        const s = document.createElement("div");
                        s.className = "ss-rec-viewport";

                        const r = document.createElement("div");
                        r.className = "ss-rec-track";

                        const a = c("prev");
                        const o = c("next");

                        s.appendChild(r);

                        i.forEach((t) => {
                            t.classList.add("ss-rec-slide");
                            r.appendChild(t);
                        });

                        e.appendChild(s);
                        e.appendChild(a);
                        e.appendChild(o);

                        const u = {
                            root: e,
                            viewport: s,
                            track: r,
                            prev: a,
                            next: o,
                            slides: Array.from(r.children),
                            index: 0,
                            maxIndex: 0,
                            visibleSlides: 0,
                            step: 0,
                            slideWidth: 0,
                            isPointerDown: !1,
                            hasDragged: !1,
                            justDragged: !1,
                            verticalLocked: !1,
                            deltaX: 0,
                        };

                        e.ssRecSlider = u;
                        S(u);
                        v(u);
                    }

                    b(e);
                },
            }.onLoad();
        theme.sections.register("searchspring-recommendations", a);
    },
});
